import { Link, makeStyles, mergeClasses, tokens, Tooltip } from "@fluentui/react-components";
import { AirplaneFilled, AppsFilled, BeakerFilled, BoardFilled, DataTrendingFilled, ProductionFilled, QuestionCircleFilled, SettingsFilled } from "@fluentui/react-icons";
import { useContext } from "react";
import { NavContext } from "./contexts/NavContextProvider";

const useStyles = makeStyles({
    sidebarLink: {
        backgroundColor: "transparent",
        height: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: tokens.colorNeutralForeground1,
        textDecoration: "none",
        padding: "0 0.5rem",
        minWidth: "50px",
        fontSize: "1.5rem",

        "&:hover": {
            color: tokens.colorNeutralForeground1,
            textDecoration: "none",
            backgroundColor: "#00000033"
        },
        "&:active": {
            color: tokens.colorNeutralForeground1,
            textDecoration: "none",
            backgroundColor: "#00000022"
        },

        "&.active": {
            backgroundColor: tokens.colorBrandBackground3Static + " !important",
            color: tokens.colorNeutralForegroundStaticInverted + " !important"
        }
    }
});

export default function Sidebar() {
    const styles = useStyles();
    const { navData } = useContext(NavContext);

    return (
        <>
            <Tooltip content="Dashboard" relationship="label" positioning="after">
                <Link href="/dashboard" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "dashboard" ? "active" : "")}>
                    <BoardFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Products" relationship="label" positioning="after">
                <Link href="/products" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "products" ? "active" : "")}>
                    <AppsFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Builds" relationship="label" positioning="after">
                <Link href="/builds" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "builds" ? "active" : "")}>
                    <ProductionFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Flight Operations" relationship="label" positioning="after">
                <Link href="/flightops" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "flightops" ? "active" : "")}>
                    <AirplaneFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Experiments" relationship="label" positioning="after">
                <Link href="/experiments" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "experiments" ? "active" : "")}>
                    <BeakerFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Telemetry" relationship="label" positioning="after">
                <Link href="/telemetry" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "telemetry" ? "active" : "")}>
                    <DataTrendingFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Settings" relationship="label" positioning="after">
                <Link href="/settings" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "settings" ? "active" : "")}>
                    <SettingsFilled />
                </Link>
            </Tooltip>
            <Tooltip content="Help &amp; Support" relationship="label" positioning="after">
                <Link href="/help" className={mergeClasses(styles.sidebarLink, navData.sidebarSelectedNavValue == "help" ? "active" : "")}>
                    <QuestionCircleFilled />
                </Link>
            </Tooltip>
        </>
    );
}